import { handleEventBusEvent } from 'reaxl-analytics-handlers';
import { eventBus } from '@atc/cai-event-bus';
export default function useEventBusAnalytics(_ref, getDataLayer, option) {
  let {
    history
  } = _ref;
  // Remove previous eventBus TrackingEvent if it exists.
  const trackingEvents = eventBus?.all?.get('TrackingEvent');
  if ((trackingEvents || []).some((event, i) => {
    if (event.key === 'onEventBusMessage') {
      trackingEvents.splice(i, 1);
      return true;
    }
    return false;
  })) {
    eventBus?.all?.set('TrackingEvent', trackingEvents);
  }

  // Add eventBus TrackingEvent
  const onEventBusAnalyticsMessage = data => handleEventBusEvent({
    history
  }, data, getDataLayer, option);
  const onEventBusMessage = eventData => {
    if (eventData.event === 'analytics_event') {
      onEventBusAnalyticsMessage(eventData);
    }
  };
  onEventBusMessage.key = 'onEventBusMessage';
  eventBus?.on('TrackingEvent', onEventBusMessage);
}